import {
  useGetReportFileDownloadLinkLazyQuery,
  useGetReportFileDownloadLinkQuery,
} from '@occc/graphql';

export const useGetAudienceReportFileDownloadLink = (reportUuid?: string) => {
  const response = useGetReportFileDownloadLinkQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    skip: !reportUuid,
    variables: {
      reportUuid: reportUuid ?? '',
    },
  });

  return {
    ...response,
    s3Url: response.data?.getReportFileDownloadLink,
  };
};

export const useGetAudienceReportFileDownloadLinkLazy = () => {
  const [fetch, result] = useGetReportFileDownloadLinkLazyQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  return {
    fetch,
    ...result,
    s3Url: result.data?.getReportFileDownloadLink,
  };
};
